<template>
  <div class="body">
    <div class="plate_title">
      <div class="plate_title_name">红包雨活动</div>
    </div>
    <div class="bb p30">
      <div class="mb20">
        <el-button type="primary" @click="handleFormShow()">添加活动</el-button>
      </div>
      <!-- 数据列表 -->
      <div v-loading="listLoading">
        <el-table :data="list" height="70vh" style="width: 100%">
          <el-table-column label="ID" width="80" prop="id"> </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="活动名称"
            width="200"
            prop="activity_title"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="活动状态" width="100">
            <template #default="scope">
              <el-tag v-if="scope.row.status == 1" type="info">待开始</el-tag>
              <el-tag v-if="scope.row.status == 2" type="primary"
                >倒计时</el-tag
              >
              <el-tag v-if="scope.row.status == 3" type="success"
                >发放中</el-tag
              >
              <el-tag v-if="scope.row.status == 4" type="danger">已结束</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="中奖名单"
            width="100"
            align="center"
          >
            <template #default="scope">
              <el-link
                @click="showWinnerList(scope.row)"
                type="primary"
                :disabled="scope.row.status != 4"
                >查看</el-link
              >
            </template>
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="创建人"
            width="100"
            prop="user.nickname"
          >
          </el-table-column>
          <el-table-column
            label="红包雨图标显示时间"
            width="180"
            prop="start_time_text"
          >
          </el-table-column>
          <el-table-column
            label="红包雨开始降雨时间"
            width="180"
            prop="redpack_time_text"
          >
          </el-table-column>
          <el-table-column
            label="红包雨持续时间(秒)"
            width="180"
            prop="end_minute"
          >
          </el-table-column>
          <el-table-column
            label="红包雨结束后入口隐藏时间"
            width="200"
            prop="activity_end_time_text"
          >
          </el-table-column>
          <el-table-column label="创建时间" width="180" prop="createtime_text">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200"
            align="center"
          >
            <template #default="scope">
              <el-button
                v-if="scope.row.status == 1"
                type="primary"
                size="default"
                @click="handleFormShow(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="default"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 弹出表单 -->
    <el-dialog
      :before-close="handleClose"
      width="500px"
      v-model="formShow"
      :title="formTitle"
    >
      <div class="flex">
        <el-form ref="form" :model="form" label-width="180px">
          <el-form-item label="红包雨图标显示时间">
            <el-date-picker
              v-model="form.start_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="红包雨开始降雨时间">
            <el-date-picker
              v-model="form.redpack_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="红包雨持续时间(秒)">
            <el-input-number
              size="mini"
              v-model="form.end_minute"
              @change="handleChange"
              :min="1"
              label="描述文字"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="红包雨结束后入口隐藏时间">
            <el-date-picker
              v-model="form.activity_end_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- <el-dialog
      title="中奖名单"
      v-model="winnerListShow"
      width="470px"
      @close="
        winnerListShow = false;
        getList();
      "
    >
      <div>
        <el-table :data="winnerList" border style="width: 100%" height="400px">
          <el-table-column prop="company_name" label="头像" width="110" />
          <el-table-column prop="name" label="昵称" width="200" />
          <el-table-column prop="asset" label="手机号" width="120" />
        </el-table>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      list: [],
      page: 1,
      pageSize: 15,
      total: 0,
      name: "", // 分类名称检索条件
      formShow: false,
      formTitle: "",
      form: {
        id: null,
        start_time: "",
        redpack_time: "",
        // end_minute: "",
        activity_end_time: "",
      }, // 提交表单信息
      // winnerListShow: false,
      // winnerList: [],
    };
  },
  mounted() {
    window.onmessageSocket = this.onmessage;
    this.getList(1);
  },
  methods: {
    onmessage(e) {},
    search() {
      this.list = [];
      this.getList(1);
    },
    async getList(page) {
      this.listLoading = true;
      const res = await request.post("/teacher/activity_redpack/getList", {
        page,
      });
      this.list = res.data.data;
      this.total = res.data.total;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.list = [];
      this.page = val;
      this.getList(val);
    },
    async onSubmit() {
      var form = this.form;
      var obj = { ...form };
      if (!obj.start_time) {
        this.$message.error("请选择红包雨图标显示时间");
        return false;
      }
      if (!obj.redpack_time) {
        this.$message.error("请选择红包雨开始降雨时间");
        return false;
      }
      // if (!obj.end_minute) {
      //   this.$message.error("请填写红包雨持续时间");
      //   return false;
      // }
      if (!obj.activity_end_time) {
        this.$message.error("请选择红包雨结束后入口隐藏时间");
        return false;
      }
      var res = null;
      if (obj.id) {
        res = await request.post("/teacher/activity_redpack/editInfo", obj);
      } else {
        res = await request.post("/teacher/activity_redpack/addInfo", obj);
      }
      this.$message.success(res.msg);
      this.formShow = false;
      this.getList(1);
    },
    handleFormShow(e) {
      if (e != undefined) {
        // 修改
        this.formTitle = "修改";
        this.form.id = e.id;
        this.form.start_time = e.start_time_text;
        this.form.redpack_time = e.redpack_time_text;
        this.form.end_minute = e.end_minute;
        this.form.activity_end_time = e.activity_end_time_text;
      } else {
        // 添加
        this.formTitle = "添加";
        this.form.id = null;
        this.form.start_time = "";
        this.form.redpack_time = "";
        this.form.end_minute = "";
        this.form.activity_end_time = "";
      }
      this.formShow = true;
    },
    handleDelete(index, row) {
      this.$confirm("确认删除该数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handleDeleteApi(index, row);
      });
    },
    async handleDeleteApi(index, row) {
      const res = await request.post("/teacher/activity_redpack/delInfo", {
        id: row.id,
      });
      this.$message.success(res.msg);
      this.getList(1);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style scoped>
.body {
  height: 100vh;
}

.plate_title {
  background-color: #f8fcff;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  padding: 18px 0;
  border-top: 1px solid #ebeced;
  border-bottom: 1px solid #ebeced;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plate_title_name {
  position: relative;
  line-height: 16px;
  padding-left: 30px;
}

.plate_title_name::before {
  content: "";
  position: absolute;
  left: 13px;
  width: 4px;
  height: 16px;
  background-color: #5389f5;
  border-radius: 5px;
}

.head > div {
  margin: 0 30px 20px 0;
  display: flex;
  align-items: center;
}

.head > div > div:first-child {
  margin-right: 10px;
  /* margin-bottom: 10px; */
}

.el-form {
  width: 90%;
}

.icon_del {
  display: block;
  width: 26px;
  height: 26px;
  margin-left: 10px;
}
</style>
